// @ts-expect-error untyped module
import { getIsPublicApp } from '../../selectors/app';
import { getPublicUnifiedMarketplaceUrl, getUnifiedMarketplaceUrl
// @ts-expect-error untyped module
} from '../../utils/urls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MarketplaceBreadcrumb({
  linkUse
}) {
  const lang = getLang();
  const isPublicApp = useSelector(getIsPublicApp);
  return /*#__PURE__*/_jsxs(Breadcrumbs, {
    paddingInline: "0",
    marginBlockStart: "600",
    children: [/*#__PURE__*/_jsx(Link, {
      href: isPublicApp ? getPublicUnifiedMarketplaceUrl(lang) : getUnifiedMarketplaceUrl(),
      use: linkUse,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.breadcrumbs.marketplace"
      })
    }), /*#__PURE__*/_jsx("span", {
      title: I18n.text('ecosystem-marketplace-solutions-ui.breadcrumbs.solutionsDirectory'),
      children: I18n.text('ecosystem-marketplace-solutions-ui.breadcrumbs.solutionsDirectory')
    })]
  });
}